import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import PersonalInfo from 'features/application/screens/PersonalInfo/PersonalInfo';
import useCustomerApplicationOrigination from 'features/signup/hooks/useCustomerApplicationOrigination';
import React from 'react';
import { useTranslation } from 'react-i18next';

const PersonalInfoWrapper = () => {
  const {
    application,
    fetching,
    error,
    reExecuteQuery,
    isReapplication,
    hasApplicationLoaded,
  } = useCustomerApplicationOrigination({
    sourceName: SourceName.PERSONAL_INFORMATION,
  });

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: application?.id,
    sourceName: SourceName.PERSONAL_INFORMATION,
  });

  const { t: translatedText } = useTranslation('signup', {
    keyPrefix: 'personalInfo',
  });

  return (
    <PersonalInfo
      firstName={application?.firstName as string}
      lastName={application?.lastName as string}
      applicationId={application?.id as string}
      isReapplication={isReapplication}
      hasApplicationLoaded={hasApplicationLoaded}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      reExecuteQuery={reExecuteQuery}
      fetching={fetching}
      error={error as Error}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      buttonLabel={translatedText('buttons.next')}
      nextRoute="/signup/address-collection"
    />
  );
};

export default PersonalInfoWrapper;
